
import { Component, Vue, Watch } from "vue-property-decorator";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import UserService from "@/services/auth/UserService";
import Multiselect from "vue-multiselect";
import ProfileService from "@/services/auth/ProfileService";
import ActionService from "@/services/lead/ActionService";
import vSelect from "vue-select";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
// import "datatables.net-buttons-bs4";
import { mapGetters } from "vuex";

@Component({
  components: {
    LayoutDefault,
    Multiselect,
    vSelect,
  },

    computed: {
        ...mapGetters('auth', ['allowedFeature'])
    }
})
export default class User extends Vue {
  /** Help to control show loading icon */
  private loading: boolean = false;
  private loadingModal: boolean = false;
  private editing: boolean = false;
  private passwordFieldType:string = 'password';
  private isEditPassword: boolean = false;

  /* User object */
  private user = {
    id_user: null as null | number,
    name: null as null | string,
    nickname: null as null | string,
    person_email: null as null | string,
    id_zapguru: null as null | string,
    email: null as null | string,
    phone: null as null | string,
    cpf: null as null | string,
    password: null as null | string,
    is_pj: null as null | boolean,
    status: null as null | any,
    phone_zapguru: null as null | any,
    items_platform_profile: [
      {
        platform_id: null as null|any,
        platform_label: null as null|any,
        profile_id: null as null|any,
        profile_label: null as null|any,
        profile_name: null as null|any,
        actions_campain: null as null|any,
        actions_id: null as null|any,
      }
    ]
  };

  private get isPlatformInvalid() {
    return false;
  }

  /** Profile list returned from backend */
  private profileList: any = [];
  private platformList: any = [];
  private statusList: any = [];
  private phonesZapguruList: any = [];
  private actionList: any = [];

  /** Object binded to v-model of the profile selector */
  private selectedProfile: {
    id_profile: number;
    label: string;
    name: string;
  } | null = null;

  private selectedPlatform: {
    id: number;
    name: string
  } | null = null;

  private selectedAction: {
    created_at: string
    description: string
    fk_id_status: number
    id_action: number
    label: string
    name: string
    updated_at: string
  }[] | null = null;

  private selectedStatus: {
    label: string;
    id_status: number;
    name: string;
  } | null = null;


   private selectedPhoneZapguru: {
    number: string;
    id: number;
    name: string;
  } | null = null;

  private pathAvatarSuffix:string = process.env.NODE_ENV === 'development'
    ? 'development'
    : 'production';

  /** PA/PJ options */
  private paPjOptions: { label: string; value: boolean }[] = [
    { label: "PA", value: false },
    { label: "PJ", value: true },
  ];

  /** Function that is called when a pa/pj option is selected */
  private paPjSelected(selectedOption: { label: string; value: boolean }) {
    this.user.is_pj = selectedOption.value;
  }

  private updateStatus(selectedOption: any ) {
    this.user.status = selectedOption.id_status;
  }

  private updateZapguruPhone(selectedOption: any ) {
    this.user.phone_zapguru = selectedOption.map((e) => e.id_phone_zapguru);
  }

  private async platformSelected(selectedOption: { id: number; name: string }) {
      let actionService = new ActionService();
      let actionList = await actionService.indexStatus('action_active', selectedOption.id);
      this.actionList = actionList.body.filter((e:any) => e.name != 'self-service');
  }

  /** Object binded to v-model of the pa/pj selector */
  private selectedPapj: { label: string; value: boolean } | null = null;

  /** Help control error form for send or not */
  private userFormError = {
    name: { state: null as boolean | null, message: "" },
    email: { state: null as boolean | null, message: "" },
    person_email: { state: null as boolean | null, message: "" },
    nickname: { state: null as boolean | null, message: "" },
    cpf: { state: null as boolean | null, message: "" },
    phone: { state: null as boolean | null, message: "" },
    password: { state: null as boolean | null, message: "" },
    profile: { state: null as boolean | null, message: "" },
    papj: { state: null as boolean | null, message: "" },
    status: { state: null as boolean | null, message: "" },
    platform: { state: null as boolean | null, message: "" },
    action: { state: null as boolean | null, message: "" },
  };

  private itemsPlatformProfile: {
          platform_id: number,
          platform_label: string,
          profile_id: number,
          profile_label: string,
          profile_name: string,
          actions_campain: string,
          actions_id: Array<number>
        }[] = [];

  private fieldsPlatformProfile = [
    { key: 'platform_label', label: 'Plataforma' },
    { key: 'profile_label', label: 'Perfil' },
    { key: 'actions_campain', label: 'Ações' },
    { key: 'actions', label: '' }
  ];

  private removeItemPlatformProfifle(item, index, element) {
    this.itemsPlatformProfile.splice(index, 1);
  }

  private addAllItemsPlatform(){
      if(!this.selectedProfile)
        return this.validatingNullPlatform = true;

      this.platformList.map((e) => {
          this.itemsPlatformProfile.push(
              {
              platform_id: e.id,
              platform_label: e.name,
              profile_id: this.selectedProfile!.id_profile,
              profile_label: this.selectedProfile!.label,
              profile_name: this.selectedProfile!.name,
              actions_campain: this.selectedAction!.map(e => e.label).join(', '),
              actions_id: this.selectedAction!.map(e => e.id_action)
              }
          )

            this.itemsPlatformProfile = this.itemsPlatformProfile.filter((e, index, self) =>
                    index === self.findIndex((t) => (
                    t.platform_id === e.platform_id
                ))
            );

      })

  }

  private get platformLimitReached() {
    return this.itemsPlatformProfile.length >= 25;
  }

  private addItemPlatformProfifle() {
    if (this.platformLimitReached) {
      return;
    }

    if (!this.selectedProfile || !this.selectedAction || !this.selectedPlatform) {
      this.validatingNullPlatform = true
      return false;
    } else {
      this.validatingNullPlatform = false

      let duplicatePlatformIndex = this.itemsPlatformProfile.findIndex(e => e.platform_id === this.selectedPlatform!.id);
      if (duplicatePlatformIndex >= 0)
        this.itemsPlatformProfile.splice(duplicatePlatformIndex, 1);

      this.itemsPlatformProfile.push(
        {
          platform_id: this.selectedPlatform.id,
          platform_label: this.selectedPlatform.name,
          profile_id: this.selectedProfile.id_profile,
          profile_label: this.selectedProfile.label,
          profile_name: this.selectedProfile.name,
          actions_campain: this.selectedAction.map(e => e.label).join(', '),
          actions_id: this.selectedAction.map(e => e.id_action)
        }
      )

      this.selectedProfile = null;
      this.selectedAction = null;
      this.selectedPlatform = null;
    }
  }

  /** Helps to show what fields are invalid only after trying to submit the form */
  private validatingNull = false;

  private validatingNullPlatform = false;

  private get nameState() {
    if (!this.validatingNull && this.user.name === null) {
      this.userFormError.name.state = null;
    } else if (
      (this.validatingNull && this.user.name === null) ||
      this.user.name === ""
    ) {
      this.userFormError.name.message = "Campo obrigatório";
      this.userFormError.name.state = false;
    } else {
      this.userFormError.name.state = true;
    }
    return this.userFormError.name.state;
  }

  private get cpfState() {

    if (
      (!this.validatingNull && this.user.cpf === null) ||
      (this.editing && [null, ""].includes(this.user.cpf))
    ) {
      this.userFormError.cpf.state = null;
    } else if (
      ((!this.editing && this.user.cpf !== null) ||
        (this.editing && ![null, ""].includes(this.user.cpf))) &&
        !this.cpfValidation(this.user.cpf as string)
    ) {
      this.userFormError.cpf.message = "CPF invalido";
      this.userFormError.cpf.state = false;
    } else {
      this.userFormError.cpf.state = true;
    }
    return this.userFormError.cpf.state;
  }

  private get nicknameState() {
    if (!this.validatingNull && this.user.nickname === null) {
      this.userFormError.nickname.state = null;
    } else {
      this.userFormError.nickname.state = true;
    }
    return this.userFormError.nickname.state;
  }

  private get emailState() {
    if (!this.validatingNull && this.user.email === null) {
      this.userFormError.email.state = null;
    } else if (
      (this.validatingNull && this.user.email === null) ||
      this.user.email === ""
    ) {
      this.userFormError.email.message = "Campo obrigatório";
      this.userFormError.email.state = false;
    } else if (
      this.user.email !== null &&
      this.user.email.match(
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/gi
      ) === null
    ) {
      this.userFormError.email.message = "E-mail inválido";
      this.userFormError.email.state = false;
    } else {
      this.userFormError.email.state = true;
    }
    return this.userFormError.email.state;
  }

  private get personEmailState() {
    if (!this.validatingNull && !this.user.person_email) {
      this.userFormError.person_email.state = null;
      this.userFormError.person_email.message = "";
    } else if (
      !!this.user.person_email &&
      this.user.person_email.match(
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/gi
      ) === null
    ) {
      this.userFormError.person_email.message = "E-mail inválido";
      this.userFormError.person_email.state = false;
    } else {
      this.userFormError.person_email.state = true;
    }
    return this.userFormError.person_email.state;
  }

  private get phoneState() {
    if (!this.validatingNull && this.user.phone === null) {
      this.userFormError.phone.state = null;
    } else if (
      (this.validatingNull && this.user.phone === null) ||
      this.user.phone === ""
    ) {
      this.userFormError.phone.message = "Campo obrigatório";
      this.userFormError.phone.state = false;
    } else if (
      this.user.phone !== null &&
      this.user.phone.match(/^\(\d{2}\) 9?\d{4}-\d{4}$/g) === null
    ) {
      this.userFormError.phone.message = "Telefone inválido";
      this.userFormError.phone.state = false;
    } else {
      this.userFormError.phone.state = true;
    }
    return this.userFormError.phone.state;
  }

  private get passwordState() {
    const password: string = this.user.password || '';
    const fullName: string = this.user.name || '';

    if (!this.isEditPassword) return true

    if (password === null) {
      this.userFormError.password.message = 'Senha não pode ser vazia';
      this.userFormError.password.state = false;
      return this.userFormError.password.state;
    }

    if (fullName === null) {
      this.userFormError.password.message = 'Nome não pode ser vazio';
      this.userFormError.password.state = false;
      return this.userFormError.password.state;
    }

    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+~`|}{[\]:;?><,./-]/.test(password);
    const isLongEnough = password.length >= 12;
    const hasSequentialNumbers = /012|123|234|345|456|567|678|789|890|098|987|876|765|654|543|432|321|210/.test(password);
    const names = fullName.split(' ').filter(name => name.length > 2);
    const containsName = names.some(name => new RegExp(name, 'i').test(password));

    const blockedWords = ['adm', 'admin', 'mudar'];
    const foundBlockedWord = blockedWords.find(word => new RegExp(word, 'i').test(password));

    if (!hasUppercase) {
      this.userFormError.password.message = 'A senha deve conter pelo menos uma letra maiúscula.';
      this.userFormError.password.state = false;
    } else if (!hasLowercase) {
      this.userFormError.password.message = 'A senha deve conter pelo menos uma letra minúscula.';
      this.userFormError.password.state = false;
    } else if (!hasNumber) {
      this.userFormError.password.message = 'A senha deve conter pelo menos um número.';
      this.userFormError.password.state = false;
    } else if (!hasSpecialChar) {
      this.userFormError.password.message = 'A senha deve conter pelo menos um caracter especial.';
      this.userFormError.password.state = false;
    } else if (!isLongEnough) {
      this.userFormError.password.message = 'A senha deve conter pelo menos 12 caracteres.';
      this.userFormError.password.state = false;
    } else if (hasSequentialNumbers) {
      this.userFormError.password.message = 'A senha não pode conter sequências numéricas.';
      this.userFormError.password.state = false;
    } else if (containsName) {
      this.userFormError.password.message = 'A senha não pode conter seu nome.';
      this.userFormError.password.state = false;
    } else if (foundBlockedWord) {
      this.userFormError.password.message = `A senha não pode conter a palavra '${foundBlockedWord}'.`;
      this.userFormError.password.state = false;
    } else {
      this.userFormError.password.state = true;
    }

    return this.userFormError.password.state;
  }

  private get statusState() {
    if (!this.validatingNull && this.user.status === null) {
      this.userFormError.status.state = null;
    } else if (this.validatingNull && this.user.status === null) {
      this.userFormError.status.message = "Campo obrigatório";
      this.userFormError.status.state = false;
    } else if(this.selectedStatus?.name  === "user_admission" && this.itemsPlatformProfile.find((e) => e.profile_name === "platform")){
      this.userFormError.status.message = "Status não permitido para usúarios com perfil plataforma";
      this.userFormError.status.state = false;
    }else{
      this.userFormError.status.state = true;
    }
    return this.userFormError.status.state;
  }

  private get paPjState() {
    if (!this.validatingNull && this.user.is_pj === null && this.itemsPlatformProfile.find((e) => e.profile_name == 'operator')) {
      this.userFormError.papj.state = null;
    } else if (this.validatingNull && this.user.is_pj === null && this.itemsPlatformProfile.find((e) => e.profile_name == 'operator')) {
      this.userFormError.papj.message = "Campo obrigatório";
      this.userFormError.papj.state = false;
    } else {
      this.userFormError.papj.state = true;
    }
    return this.userFormError.papj.state;
  }

  private get actionState() {
    if (!this.validatingNullPlatform && this.selectedAction === null) {
      this.userFormError.action.state = null;
    } else if (this.validatingNullPlatform && this.selectedAction === null) {
      this.userFormError.action.message = "Campo obrigatório";
      this.userFormError.action.state = false;
    } else {
      this.userFormError.action.state = true;
    }
    return this.userFormError.action.state;
  }

  private get profileState() {
    if (!this.validatingNullPlatform && this.selectedProfile === null) {
      this.userFormError.profile.state = null;
    } else if (this.validatingNullPlatform && this.selectedProfile === null) {
      this.userFormError.profile.message = "Campo obrigatório";
      this.userFormError.profile.state = false;
    } else {
      this.userFormError.profile.state = true;
    }
    return this.userFormError.profile.state;
  }

  private get platformState() {
    if (!this.validatingNullPlatform && this.selectedPlatform === null) {
      this.userFormError.platform.state = null;
    } else if (this.validatingNullPlatform && this.selectedPlatform === null) {
      this.userFormError.platform.message = "Campo obrigatório";
      this.userFormError.platform.state = false;
    } else {
      this.userFormError.platform.state = true;
    }
    return this.userFormError.platform.state;
  }

  /**
   * Method for validation of add user form
   */
  private validateForm() {
    this.validatingNull = true;
    if (
      !this.nameState || !this.emailState || !this.phoneState ||
      !(this.passwordState || (this.passwordState === null && this.editing)) ||
      !this.paPjState || !this.statusState
    ) {
      return false;
    }
    return true;
  }

  /**
   * @type boolean
   * Help to control error message
   */
  private showDangerAlert: boolean = false;
  private dangerAlertMessage: string = "";

  /**
   * @type boolean
   * Help to control success message
   */
  private showSuccessAlert: boolean = false;
  private successAlertMessage: string = "";

  /** Datatables object */
  private userList: any;

  /**
   * @tyoe Array
   * Define columns from datatables
   */
  private columns = [
    {
      data: "picture_url",
      name: "picture",
      title: "Foto",
      orderable: false,
      defaultContent: "",
    },
    {
      data: "id_user",
      name: "id_user",
      title: "ID",
      orderable: true,
      searchable: true,
    },
    {
      data: "name",
      name: "name",
      title: "Nome",
      orderable: true,
      searchable: true,
    },
    {
      data: "email",
      name: "email",
      title: "E-mail",
      orderable: true,
      searchable: true,
    },
    {
      data: "phone",
      name: "phone",
      title: "Telefone",
      orderable: true,
      searchable: true,
    },
    {
      data: "id_profile",
      name: "profile",
      title: "Perfil",
      orderable: true,
      searchable: true,
    },
    {
      data: "is_pj",
      name: "is_pj",
      title: "PA/PJ",
      orderable: true,
      searchable: true,
    },
    {
      data: "status",
      name: "status",
      title: "Status",
      orderable: true,
      searchable: true,
    },
    {
      data: "id_status",
      name: "id_status",
      visible: false,
    },
    {
      data: "platform",
      name: "platform",
      title: "Plataforma",
      orderable: true,
      searchable: true,
    },
    {
      data: "person_email",
      name: "person_email",
      title: "E-mail Pessoal",
      orderable: true,
      searchable: true,
      visible: false,
    },
    {
      data: "nickname",
      name: "nickname",
      title: "Nickname",
      orderable: true,
      searchable: true,
      visible: false,
    },
    {
      data: "cpf",
      name: "cpf",
      title: "CPF",
      orderable: true,
      searchable: true,
      visible: false,
    },
    {
      data: "id_zapguru",
      name: "id_zapguru",
      title: "Id Zapguru",
      orderable: true,
      searchable: true,
      visible: false,
    },
    {
      data: "phone_zapguru",
      name: "phone_zapguru",
      title: "Telefone Zapguru",
      orderable: true,
      searchable: true,
      visible: false,
    },
    {
      data: "actions",
      name: "actions",
      title: "Editar",
      orderable: false,
      defaultContent: "--",
      searchable: false,
    },
  ];

  /**
   * @type Array
   * Set config for Datatable buttons
   */
  private buttons: any = [];

  /**
   * Method created life cycle
   */
  private created() {}

  /**
   * Choose between add and update method
   */
  private formSubmit() {
    if(this.itemsPlatformProfile.length <= 0)
        return this.validatingNullPlatform = true

    return this.editing ? this.updateUser() : this.addUser();
  }

  /** Method that adds a new user */
  private async addUser() {
    if (!this.validateForm()) return;

    this.loading = true;

    try {
      this.user.items_platform_profile = this.itemsPlatformProfile;

      let userService = new UserService();
      let response = await userService.store(this.user as any);
      this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Usuário adicionado com sucesso!');
      // this.showDangerAlert = false;
      // this.successAlertMessage = "Usuário adicionado com sucesso!";
      // this.showSuccessAlert = true;

      this.userList.ajax.reload();
    } catch (error) {
      console.log(error);
      this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao adicionar usuário.');
    } finally {
      this.loading = false;
      this.closeUserModal();
    }
  }

  private showPassword() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
  }
  /**
   * Method that updates a user
   */
  private async updateUser() {
    if (!this.validateForm()) return;

    this.loading = true;
    this.user.items_platform_profile = this.itemsPlatformProfile;

    try {
      let userService = new UserService();
      let response = await userService.update(this.user as any);

      console.log(response);
      this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Usuário modificado com sucesso!');
      this.userList.ajax.reload();
    } catch (error) {
      this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao modificar usuário.');
    }

    this.loading = false;
    this.closeUserModal();
  }

  /**
   * Method close modal from add new product and reset product state
   */
  private closeUserModal() {
    this.hideModal("modal-add-user");
    this.user.id_user = null;
    this.user.name = null;
    this.user.nickname  = null;
    this.user.email = null;
    this.user.person_email = null;
    this.user.phone = null;
    this.user.phone_zapguru = null;
    this.user.password = null;
    this.user.is_pj = null;
    this.user.cpf = null;
    this.user.id_zapguru = null;
    this.user.items_platform_profile = [];
    this.selectedStatus = null;
    this.selectedProfile = null;
    this.selectedPapj = null;
    this.editing = false;
    this.validatingNull = false;
    this.validatingNullPlatform = false;
    this.selectedProfile = null;
    this.selectedAction = null;
    this.selectedPlatform = null;
    this.selectedPhoneZapguru = null;
    this.itemsPlatformProfile = [];
  }

  /**
   * Method join commands for create datatable
   */
  private createDataTable(self) {
    if (self.allowedFeature('create-user'))
        this.buttons.push({ extend: "addUser" });

    this.userList = this.$("#userList").DataTable({
      autoWidth: true,
      responsive: true,
      processing: false,
      scrollY: 500,
      scrollX: true,
      order: [[1, "asc"]],
      dom:'<"row"<"col-sm-12 col-md-5"l><"col-sm-12 col-md-7"f>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
      ajax: {
        url: process.env.VUE_APP_ROOT_API + 'auth/user-list',
        dataSrc: "",
        crossDomain: true,
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "Bearer " + localStorage.getItem("token")
          );
        },
      },
      columnDefs: [
        {
          className: "nowrap dt-center",
          render: (data, type, row) => {
            let image = `<div style="
            width: 50px; height: 50px;
            border-radius: 25px;
            background: url('https://weclever-public.s3.amazonaws.com/dashboard/avatar/${this.pathAvatarSuffix}/${row.id_user}.jpg'),
                        url('https://weclever-public.s3.amazonaws.com/dashboard/avatar/default.png') no-repeat;
            background-size: cover;"></div>`;
            return image;
          },
          targets: 0,
        },
        {
          className: "nowrap",
          render: (data, type, row) => {
            // Perfil
            return this.profileList.find(
              (element) => element.id_profile == data
            ).label;
          },
          targets: 5,
        },
        {
          className: "nowrap",
          render: (data, type, row) => {
            // PA / PJ
            return data == 1 ? "PJ" : "PA";
          },
          targets: 6,
        },
        {
          className: "nowrap dt-right",
          render: (data, type, row) => {
            let buttons = "";
            if (self.allowedFeature('edit-user')) {
              buttons +=
                "<button class='editButton' type='button' style='padding: 0; border: 0; background-color: transparent;'><i class='far fa-edit'></i></button>&nbsp;";
            }
            return buttons;
          },
          targets: this.columns.length - 1,
        },
      ],
      columns: this.columns,
      language: {
        sEmptyTable: "Nenhum registro encontrado",
        sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
        sInfoFiltered: "(Filtrados de _MAX_ registros)",
        sInfoPostFix: "",
        sInfoThousands: ".",
        sLengthMenu: "_MENU_ Qtd por página",
        sLoadingRecords: "Carregando...",
        sProcessing:
          '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
        sZeroRecords: "Nenhum registro encontrado",
        sSearch: "Pesquisar",
        oPaginate: {
          sNext: "Próximo",
          sPrevious: "Anterior",
          sFirst: "Primeiro",
          sLast: "Último",
        },
        oAria: {
          sSortAscending: ": Ordenar colunas de forma ascendente",
          sSortDescending: ": Ordenar colunas de forma descendente",
        },
        select: {
          rows: {
            _: "Selecionado %d linhas",
            "0": "Nenhuma linha selecionada",
            "1": "Selecionado 1 linha",
          },
        },
      }, //ação que é executada quando a pessoa clica no botão de editar
      buttons: this.buttons,
      drawCallback: () => {
        this.$(".editButton").click(async (e) => {
          this.editing = true;
          this.$bvModal.show("modal-add-user");

          this.user.id_user = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().id_user;

          this.loadingModal = true;
          const profileService = new ProfileService();
          this.itemsPlatformProfile = [];
          if(this.loadingModal)
            await profileService.getPlatformsProfile(this.user.id_user).then((response:any) =>{
                this.itemsPlatformProfile = response.body;
            });

          this.user.name = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().name;

          this.user.nickname = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().nickname;

          this.user.person_email = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().person_email;

           this.user.email = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().email;

          this.user.phone = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().phone;

          this.user.cpf = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().cpf;

           this.user.id_zapguru = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().id_zapguru;

          this.user.is_pj = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().is_pj
            ? true
            : false;

          this.selectedPapj =
            this.paPjOptions.find(
              (element) => element.value === this.user.is_pj
            ) || null;

          this.user.status = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().id_status;

          this.selectedStatus =
            this.statusList.find(
              (element) => element.id_status === this.user.status
            ) || null;

            this.user.phone_zapguru = this.userList
            .row(this.$(e.target).parents("tr"))
            .data().phone_zapguru;

            if(this.user.phone_zapguru){
                if(typeof this.user.phone_zapguru !== 'number' ){
                    this.user.phone_zapguru = Array.from(this.user.phone_zapguru.split(','),Number)

                    this.selectedPhoneZapguru =
                    this.phonesZapguruList.filter(
                    (element) => this.user.phone_zapguru.includes(element.id_phone_zapguru)
                    ) || null;

                } else{
                    this.selectedPhoneZapguru =
                    this.phonesZapguruList.find(
                    (element) => element.id_phone_zapguru == this.user.phone_zapguru
                    ) || null;
                }

            }

            this.loadingModal = false;
        });
      },
    });

    this.userList.buttons().container().appendTo("#dt-actions");
  }

  private cpfValidation(cpf:string) {
    if (typeof cpf !== "string")
      return false;

    cpf = cpf.replace(/[\s.-]*/igm, '');
    if (!cpf ||cpf.length != 11 ||cpf == "00000000000" ||cpf == "11111111111" ||cpf == "22222222222" ||
        cpf == "33333333333" ||cpf == "44444444444" || cpf == "55555555555" ||cpf == "66666666666" ||
        cpf == "77777777777" ||cpf == "88888888888" || cpf == "99999999999" )
        return false;

    let sum = 0;
    let rest;
    for (let i = 1; i <= 9; i++)
        sum = sum + parseInt(cpf.substring(i-1, i)) * (11 - i)

    rest = (sum * 10) % 11;
    if ((rest == 10) || (rest == 11))
      rest = 0;

    if (rest != parseInt(cpf.substring(9, 10)))
      return false;

    sum = 0;
    for (let i = 1; i <= 10; i++)
      sum = sum + parseInt(cpf.substring(i-1, i)) * (12 - i);

    rest = (sum * 10) % 11;
    if ((rest == 10) || (rest == 11))
      rest = 0;

    if (rest != parseInt(cpf.substring(10, 11)))
      return false;

    return true;
  }

  /**
   * Method mounted from life cycle
   */
  private async mounted() {
    let self = this;

    this.loading = true;

    try {
      let profileService = new ProfileService();
      let status = await profileService.getStatus();
      let profiles = await profileService.getProfile();
      let platformList = await profileService.getPlatform();
      let phonesZapguruList = await profileService.getPhonesZapguru();
      this.statusList = status.body;
      this.profileList =  profiles.body;
      this.platformList = platformList.body;
      this.phonesZapguruList = phonesZapguruList.body;
    } catch (error) {
      console.log(error);
    }

    this.$.fn.dataTable.ext.buttons.addUser = {
      text: '<i class="fas fa-plus"></i>',
      className: "datatable-buttons pr-0 pl-0",
      titleAttr: "Adicionar usuário",
      action: function (e, dt, node, config) {
        self.$bvModal.show("modal-add-user");
      },
    };

    try {
      this.createDataTable(this);
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  /**
   * Method before create from life cycle
   */
  private beforeCreate() {
    document.body.className = "";
  }
}
